"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpotsWidgetRenderer = void 0;
/* eslint-disable max-len */
const helpers_1 = require("@/app/shared/helpers");
const labels_1 = __importDefault(require("@/app/shared/i18n/labels"));
class SpotsWidgetRendererImpl {
    renderHTML(payload) {
        const durationStr = this.getDuration(payload.duration);
        const timeZone = this.getTimeZone();
        const info = this.renderSpots(payload);
        return this.renderContainer(payload.spotUrl, durationStr, timeZone, info);
    }
    getDuration(duration) {
        return duration.count + (duration.timeUnit === 'MINUTE' ? 'm' : 'h');
    }
    getTimeZone() {
        // See https://stackoverflow.com/questions/1954397/detect-timezone-abbreviation-using-javascript
        // Or https://github.com/evancz/time-zone-proposal
        // for alternative options
        return new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];
    }
    formatDate(d) {
        const date = d.toLocaleDateString('en-US', { day: 'numeric', weekday: 'short', month: 'short' });
        const time = d.toLocaleDateString('en-US', { minute: 'numeric', hour: 'numeric' }).split(', ').pop();
        return { date, time };
    }
    splitSpots(spots) {
        const result = [];
        let maxSpots = 0;
        for (const spot of spots) {
            const date = new Date(spot);
            const dateKey = `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
            let existingEntry = result.find((entry) => {
                const entryKey = `${entry.date.getFullYear()}-${entry.date.getMonth()}-${entry.date.getDate()}`;
                return entryKey === dateKey;
            });
            if (existingEntry) {
                existingEntry.dates.push(date);
            }
            else {
                existingEntry = { date, dates: [date] };
                result.push(existingEntry);
            }
            if (existingEntry.dates.length > maxSpots) {
                maxSpots = existingEntry.dates.length;
            }
        }
        return {
            maxSpots,
            result,
        };
    }
    renderSpots(payload) {
        const COLOR = 'white';
        const BG_COLOR = '#0197F6';
        const headers = [];
        const rows = [];
        const { result: dayToSpots, maxSpots } = this.splitSpots(payload.spots);
        for (const { date } of dayToSpots) {
            const { date: formattedDate } = this.formatDate(date);
            headers.push(`
        <th style="padding: 10px;font-size: 14px;font-weight: 800;text-align: center">
          ${formattedDate}
        </th>
      `);
        }
        for (let i = 0; i < maxSpots; i++) {
            let row = '<tr>';
            for (const { dates } of dayToSpots) {
                const spot = dates[i];
                if (!spot) {
                    row += '<td></td>';
                    continue;
                }
                const { time } = this.formatDate(spot);
                const href = helpers_1.query.add(payload.spotUrl, {
                    [payload.querySpotKey]: payload.querySpotFormat === 'number' ? spot.getTime() : spot.toISOString(),
                });
                row += `
          <td style="padding: 4px 2px" align="center">
            <a style="display: inline-block; font-size: 14px; color:${COLOR}; background-color: ${BG_COLOR}; padding: 10px 20px; border-radius: 15px; text-decoration: none; cursor: pointer" href="${href}">
              ${time}
            </a>
          </td>
        `;
            }
            row += '</tr>';
            rows.push(row);
        }
        return { columns: dayToSpots.length, headers, rows };
    }
    renderContainer(link, duration, timeZone, { columns, headers, rows }) {
        const linkText = labels_1.default.SPOTS_WIDGET_CLICK_HERE;
        const descriptionText = rows.length ? labels_1.default.SPOTS_WIDGET_VIEW_MORE_OPTIONS : labels_1.default.SPOTS_WIDGET_SELECT_TIME_SLOT;
        return `
      <br>
      <br>
      <br>
      <table style="border-collapse: collapse;clear:both;">
        <thead>
          <tr>
            <th colspan="${columns}" style="text-align: left;">
              <p>
                <span style="float: left;">Duration: ${duration}</span>
                <span style="float: right;">Time Zone: ${timeZone}</span>
              </p>
            </th>
          </tr>
          <tr>
            ${headers.join('\n')}
          </tr>
        </thead>
        <tbody>
          ${rows.join('\n')}
          <tr>
            <td colspan="${columns}">
              <p style="text-align: right">
                <a href="${link}" target="_blank">${linkText}</a> ${descriptionText}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    `;
    }
}
exports.SpotsWidgetRenderer = new SpotsWidgetRendererImpl();
